import Head from 'next/head';
import { OneTapLoginWrapped } from '../../bookings/Login/FullLogin/OneTapLogin';
import { PageType, PageSection, SubSection } from '../../common/AnalyticsContext/TrackingData';
import { TrackingEvent } from '../../common/AnalyticsContext/TrackingEvent';
import { useAnalytics } from '../../common/AnalyticsContext/useAnalytics';
import { useExperiment } from '../../common/ExperimentContext/useExperiment';
import { AnnouncementBannerExperiment } from '../../common/Experiments/AnnouncementBannerExperiment';
import { useHomepageTiles } from '../../common/Experiments/HomepageTilesExperiment';
import { AnnouncementBanner } from '../../common/components/AnnouncementBanner/AnnouncementBanner';
import { BottomNavigationBar } from '../../common/components/BottomNavigationBar/BottomNavigationBar';
import { Footer } from '../../common/components/Footer/Footer/Footer';
import { GlobalSeo } from '../../common/components/GlobalSeo';
import { PageContentContainer } from '../../common/components/layout/PageContainer';
import { useAbsoluteUrl } from '../../common/hooks/useAbsoluteUrl';
import { useEffectOnceOnMount } from '../../common/hooks/useEffectOnceOnCondition';
import { useSearch } from '../../common/hooks/useSearch';
import { DownloadAppSection } from '../Sections/DownloadAppSection/DownloadAppSection';
import { HealthCareProviderSection } from '../Sections/HealthCareProviderSection/HealthCareProviderSection';
import {
  HomeHeroSection,
  HomeHeroSectionExperiment,
} from '../Sections/HomeHeroSection/HomeHeroSection';
import { HomeInformationSection } from '../Sections/HomeInformationSection/HomeinformationSection';
import { MoreAboutHealthEngineSection } from '../Sections/MoreAboutHealthengineSection/MoreAboutHealthengineSection';
import { MyCareTeamSection } from '../Sections/MyCareTeamSection/MyCareTeamSection';
import { PopularSearchesSection } from '../Sections/PopularSearchesSection/PopularSearchesSection';
import { PHIBannerSection } from '../Sections/PrescriptionSection/ExperimentVariations/PHIBannerSection';
import { HomepageHeaderLayout } from './HomepageHeaderLayout';

export const Homepage = () => {
  const { searchSpecialty, setSearchSpecialty } = useSearch();
  const announcementBannerExperiment = useExperiment(AnnouncementBannerExperiment);

  const absoluteUrl = useAbsoluteUrl();

  const { trackEvent } = useAnalytics({
    pageData: {
      pagePath: '/',
      pageType: PageType.HOMEPAGE,
      section: PageSection.CONSUMER,
      subsection: SubSection.HOME,
    },
  });

  useEffectOnceOnMount(() => {
    trackEvent(TrackingEvent.PAGE_LOADED);
  });

  const homepageTilesExperiment = useHomepageTiles();

  return (
    <>
      <Head>
        <title>Find a Doctor, GP, Dentist or Healthcare Specialist Near You</title>
        <meta
          name="description"
          content="Book Doctor, GP, Dentist or Healthcare Specialist Appointments Online. Millions of
          Appointments with Trusted Practitioners Available 24/7, Australia-Wide."
        />
        <meta key="homepage-banner"></meta>
      </Head>
      <GlobalSeo absoluteUrl={absoluteUrl} />

      <OneTapLoginWrapped />

      <HomepageHeaderLayout
        onClearSearch={() => setSearchSpecialty(null)}
        searchSpecialty={searchSpecialty}
        banner={<div className="branch-journeys-top"></div>}
      />
      <PageContentContainer>
        {announcementBannerExperiment.data && (
          <AnnouncementBanner
            title={announcementBannerExperiment.data.title}
            cta={announcementBannerExperiment.data.cta}
            ctaLink={announcementBannerExperiment.data.ctaLink}
          />
        )}
        {homepageTilesExperiment ? (
          <HomeHeroSectionExperiment
            searchSpecialty={searchSpecialty}
            setSearchSpecialty={setSearchSpecialty}
          />
        ) : (
          <HomeHeroSection
            searchSpecialty={searchSpecialty}
            setSearchSpecialty={setSearchSpecialty}
          />
        )}
        <MyCareTeamSection />
        <HomeInformationSection />
        <HealthCareProviderSection />
        <PHIBannerSection />
        <MoreAboutHealthEngineSection />
        <DownloadAppSection />
        <PopularSearchesSection />
      </PageContentContainer>
      <Footer />
      <BottomNavigationBar />
    </>
  );
};
